import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ficheApi } from "@features/fiche/api";

type Action = {
  id: string; echeanceLibelle: string; action: string; canal: string; cible: string | null; statut: string;
};

export function SequenceActions({ prospectId, actions, segment }:
  { prospectId: string; actions: Action[]; segment: string }) {
  const qc = useQueryClient();
  const maj = useMutation({
    mutationFn: (v: { id: string; statut: string }) => ficheApi.majAction(v.id, v.statut),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["fiche", prospectId] })
  });

  const construire = useMutation({
    mutationFn: () => ficheApi.genererSequence(prospectId),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["fiche", prospectId] })
  });

  if (actions.length === 0) {
    // sur un segment C l'absence de séquence est le comportement voulu ;
    // ailleurs c'est une fiche analysée avant la mise en place des séquences.
    return segment === "C" ? (
      <p className="etat">
        Aucune séquence : sur un segment C, c'est volontaire. Le temps commercial vaut plus que le ticket possible.
      </p>
    ) : (
      <section className="panel">
        <p className="etat" style={{ marginTop: 0 }}>
          Aucune séquence enregistrée pour ce segment {segment}.
        </p>
        <button className="btn" disabled={construire.isPending} onClick={() => construire.mutate()}>
          {construire.isPending ? "Construction…" : "Construire la séquence"}
        </button>
      </section>
    );
  }

  const faites = actions.filter(a => a.statut === "fait").length;

  return (
    <section className="panel">
      <h2 className="blocktitle">Séquence — {faites} / {actions.length} réalisée(s)</h2>
      {actions.map(a => (
        <div key={a.id} className={`etape-action ${a.statut === "fait" ? "done" : ""}`}>
          <span className="when">{a.echeanceLibelle}</span>
          <label>
            <input type="checkbox" checked={a.statut === "fait"}
                   onChange={e => maj.mutate({ id: a.id, statut: e.target.checked ? "fait" : "a_faire" })} />
            <span>
              <strong>{a.action}</strong>
              <br /><span className="mono petit mut">{a.canal} · cible : {a.cible ?? "—"}</span>
            </span>
          </label>
        </div>
      ))}
    </section>
  );
}
